import { render, staticRenderFns } from "./upload-video.vue?vue&type=template&id=59d89e6f&"
import script from "./upload-video.vue?vue&type=script&lang=js&"
export * from "./upload-video.vue?vue&type=script&lang=js&"
import style0 from "./upload-video.vue?vue&type=style&index=0&id=59d89e6f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports